import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import { SwitchTransition, CSSTransition } from "react-transition-group";
import { useRef } from "react";
import IntroPage from "./screen/Home";
import Menu from "./screen/Menu";
import Contact from "./screen/menu/contect";
import About from "./screen/menu/About";
import Menu_2 from "./screen/Menu_2";

function AnimatedRoutes() {
  const location = useLocation();
  const nodeRef = useRef<HTMLDivElement>(null);

  return (
    <SwitchTransition mode="out-in">
      <CSSTransition key={location.pathname} nodeRef={nodeRef} classNames="fade" timeout={600}>
        <div ref={nodeRef} className="route-transition-container" style={{ width: "100%", height: "100%" }}>
          <Routes location={location}>
            <Route path="/" element={<IntroPage />} />
            <Route path="/menu" element={<Menu />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />
          </Routes>
        </div>
      </CSSTransition>
    </SwitchTransition>
  );
}

function App() {
  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      <Router>
        <div style={{ flex: 1 }}>
          <AnimatedRoutes />
        </div>
      </Router>
    </div>
  );
}

export default App;

